import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { RootState } from 'store'
import { GigStepProperty } from 'types/campaign/collaborations'
import PropertiesPreview from '../PropertiesPreview'
import CollapsableContent from 'Components/Common/CollapsableContent'

interface FormContentApprovalProps {
    properties: GigStepProperty[]
    setSelectedMedia: (media: any) => void

}
const FormContentApproval: React.FC<FormContentApprovalProps> = ({properties, setSelectedMedia}) => {

    const {campaignId, milestoneId, collaborationId} = useParams();

    const collaborationMilestoneData = useSelector((state: RootState) => state.collaborationMilestones.collaborations[campaignId!]?.[collaborationId!]?.[milestoneId!]?.data)
    const events = collaborationMilestoneData?.events ?? [];
    const files = collaborationMilestoneData?.milestone?.files ?? [];
    const getContentStep = useCallback((property: GigStepProperty) => {
        
        const [key, step] = property?.choices?.property.split('.');
        const contentEvent = events.find((event) => event.step.gig_step.slug === step);

        if(contentEvent && key){
            switch(key){
                case 'deliverables': {
                    return contentEvent.step;
                }
            }
        }

        return null;
    }, [events])


  return (
     <CollapsableContent>
        {
            properties.map((property, i) => {
                if(property.type !== 'approval') return null;

                return (
                    <div key={i}>
                        {
                            getContentStep(property) && 
                            <PropertiesPreview 
                                step={getContentStep(property)!} 
                                deliverables={getContentStep(property)?.deliverables}
                                files={files}
                                setSelectedMedia={setSelectedMedia}
                                activeView={true}
                             />
                        }
                    </div>
                );
            })
        }
     </CollapsableContent>
  )
}

export default FormContentApproval